import { render } from "./FadedBorderWrapper.vue?vue&type=template&id=112207be"
import script from "./FadedBorderWrapper.vue?vue&type=script&lang=js"
export * from "./FadedBorderWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__